import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ShareWatchlistUsersDto } from '../../services/dtos/watchLists/shareWatchlistUsers.dto';
import { fetchShareWatchlistUsers } from '../../services/watchLists/watchLists.service';
import { queryKeys } from '../queryKeyFactory';

export default (
  options?: UseQueryOptions<ShareWatchlistUsersDto[], Error>
): UseQueryResult<ShareWatchlistUsersDto[], Error> =>
  useQuery<ShareWatchlistUsersDto[], Error>(
    [queryKeys.fetchShareWatchlists.users],
    () => fetchShareWatchlistUsers(),
    options
  );
